(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
  const video = card.querySelector('.card__media .media video');

  if (video) {
    card.addEventListener('mouseenter', () => {
      video.currentTime = 0; // Reset to start
      video.play();
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0; // Reset to start on hover out
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-featured-products"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mega-menu-product__link').forEach((card) => {
  const video = card.querySelector('.mega-menu-product__link .mega-menu-product__media video');

  if (video) {
    card.addEventListener('mouseenter', () => {
      video.currentTime = 0; // Reset to start
      video.play();
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0; // Reset to start on hover out
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
